<template>
  <Layout>
    <LayoutTitle
      title="Ulmo"
      :back-default="false"
    />
    <div class="px-4 flex gap-4 flex-col">
      <template v-if="hasSomethingToShow">
        <div
          v-if="hasUncommittedStatements"
          class="flex flex-col gap-1"
        >
          <div class="flex justify-between items-center py-2">
            <div class="text-sm text-[var(--text-secondary)] font-bold">
              CARTOLAS SIN CONFIRMAR
            </div>
            <RouterLink
              :to="{ path: '/statements'}"
              class="text-sm text-[var(--text-muted)] font-medium"
            >
              ver todo
            </RouterLink>
          </div>
          <div class="flex flex-col gap-4">
            <RouterLink
              v-for="statement in uncommittedStatements"
              :key="statement.id"
              :to="`/statements/${statement.id}`"
              class=""
            >
              <div class="flex items-center justify-around rounded-xl">
                <div class="flex items-center gap-2 min-w-0">
                  <div class="text-[var(--text-primary)] bg-[var(--bg-surface-tint)] rounded-xl p-4 w-fit">
                    <Icon
                      icon="mdi:file-document-outline"
                      class="text-xl"
                    />
                  </div>
                  <div class="text-sm truncate">
                    {{ statement.accountName || `Cartola #${statement.id}` }}
                  </div>
                </div>
                <div class="ml-auto font-bold text-sm">
                  {{ statement.status }}
                </div>
              </div>
            </RouterLink>
          </div>
        </div>
        <div
          v-if="hasPendingMovements"
          class="flex flex-col gap-1"
        >
          <div class="flex justify-between items-center py-2">
            <div class="text-sm text-[var(--text-secondary)] font-bold">
              MOVIMIENTOS PENDIENTES
            </div>
            <RouterLink
              :to="{ path: '/movements'}"
              class="text-sm text-[var(--text-muted)] font-medium"
            >
              ver todo
            </RouterLink>
          </div>
          <div class="flex flex-col gap-4">
            <RouterLink
              v-for="movement in draftMovements"
              :key="movement.id"
              :to="`/movements/${movement.id}`"
              class=""
            >
              <div class="flex items-center justify-around rounded-xl">
                <div class="flex items-center gap-2 min-w-0">
                  <div class="text-[var(--text-primary)] bg-[var(--bg-surface-tint)] rounded-xl p-4 w-fit">
                    <Icon
                      icon="material-symbols:payments-outline"
                      class="text-xl"
                    />
                  </div>
                  <div class="text-sm truncate">
                    {{
                      movement?.description
                        ?? 'Sin movement'
                    }}
                  </div>
                </div>
                <div class="text-sm font-bold w-20 ml-auto min-w-20">
                  <Currency :amount="movement?.amount" />
                </div>
              </div>
            </RouterLink>
          </div>
        </div>
      </template>
      <div
        v-else
        class="flex flex-col items-center justify-center gap-3 py-16 text-center"
      >
        <div class="text-[var(--text-primary)] bg-[var(--bg-surface-tint)] rounded-xl p-4 w-fit">
          <Icon
            icon="mdi:leaf"
            class="text-2xl"
          />
        </div>
        <div class="text-sm text-[var(--text-secondary)]">
          Por ahora todo tranquilo
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>

import transactionsApi from '@/api/transactions';
import accountsApi from '@/api/accounts';
import notificationsApi from '@/api/notifications';
import movementsApi from '@/api/movements';
import debtsApi from '@/api/debts';
import statementsApi from '@/api/statements';



export default {

  data() {
    return {
      transactions: [],
      accounts: [],
      selectedAccountIndex: 0,
      notifications: [],
      draftMovements: [],
      pendingDebts: [],

    };
  },
  computed: {
    hasPendingMovements() {
      return this.draftMovements && this.draftMovements.length > 0;
    },
    hasUncommittedStatements() {
      return this.uncommittedStatements && this.uncommittedStatements.length > 0;
    },
    hasSomethingToShow() {
      return this.hasPendingMovements || this.hasUncommittedStatements;
    },
  },
  async mounted() {
    try {
      const [
        statementsResponse,
        response,
        accountsResponse,
        notificationsResponse,
        movementsDraftResponse,
        debtsResponse,
      ] = await Promise.all([
        statementsApi.index({
          limit: 3,
          'not_status': ['commited'],
        }),
        transactionsApi.index({
          'limit': 3,
        }),
        accountsApi.index({
          'mine': true,
          'limit': 3,
          'with_balance': true,
        }),
        notificationsApi.index({
          limit: 3,
          'status': ['processed'],
          'with_matched_movement': true,
        }),
        movementsApi.index({
          limit: 3,
          status: ['draft'],
          'with_matched_movement': true,
        }),
        debtsApi.index({
          limit: 10,
        }),
      ]);

      this.uncommittedStatements = statementsResponse.data.data;
      this.transactions = response.data.data;
      this.accounts = accountsResponse.data.data;
      this.notifications = notificationsResponse.data.data;
      this.draftMovements = movementsDraftResponse.data.data;
      this.pendingDebts = debtsResponse.data.data.filter(debt => debt.remaining !== 0).slice(0, 3);
    } catch (error) {
      console.error('Error fetching transactions:', error);
    }
  },
};
</script>
